'use strict';

const DashboardLayoutStore = require('./DashboardLayoutStore'),
    _ = require('lodash'),
    ChronologycStore = require('stores/ChronologycStore'),
    ContentUtils = require('utils/ContentUtils'),
    DashboardServiceCache = require('services/DashboardServiceCache'),
    DateUtils = require('utils/DateUtils'),
    DashboardAction = require('../actions/DashboardActionCreators'),
    DashboardServiceImpl = require('services/DashboardServiceImpl');

const TankStore = {

    /**
     * Persist new tank in the application that will be available from the dashboard.
     * @param tank
     * @param {Function} success
     * @param {Function} failure
     */
    addTank(tank, success, failure) {
        DashboardServiceImpl.addTank(tank, function () {
            DashboardAction.addedTank();
            if (success) {
                success(this);
            }
        }, failure);
    },

    /**
     * Fetch tanks from the server and hydrate cache of tanks.
     * @param {Function} success
     * @param {Function} failure
     */
    fetchTanks(success, failure) {
        DashboardServiceImpl.getAllTanks(function () {
            var tanks = [].slice.call(ContentUtils.parse(this.responseText));
            DashboardServiceCache.setTanks(tanks);
            if (success) {
                success.bind(this)(tanks);
            }
        }, failure);
    },

    fetchTanksBy(filter, success, failure) {
        DashboardServiceImpl.getTanksBy(filter, function () {
            var tanks = [].slice.call(ContentUtils.parse(this.responseText));
            DashboardServiceCache.setTanks(tanks);
            if (success) {
                success.bind(this)(tanks);
            }
        }, failure);
    },

    /**
     * Change persistent tank in the application.
     * @param tank
     * @param {Function} success
     * @param {Function} failure
     */
    changeTank(tank, success, failure) {
        DashboardServiceImpl.changeTank(tank, function () {
            DashboardAction.changedTank();
            if (success) {
                success(this);
            }
        }, failure);
    },

    /**
     * Delete tanks from the application.
     * TBD: validate if need check before what happen if are orders assigned in this tank.
     * @param tank
     * @param {Function} success
     * @param {Function} failure
     */
    deleteTank(tank, success, failure) {
        DashboardServiceImpl.deleteTank(tank, function () {
            DashboardAction.deletedTank();
            if (success) {
                success();
            }
        }, failure);
    },

    setTanks(tanks) {
        DashboardServiceCache.setTanks(tanks);
    },

    /**
     * Given a range of date and type of tank, retrieve the availability of tanks.
     *
     * @param {Date} dateFrom            start range of date
     * @param {Date} dateTo              end range of date
     * @param {String} typeTank          type of tank that will check availability.
     * @param {String} orderId           (optional) of the existing order.
     * @return {Array}
     */
    getAvailabilityTanks(dateFrom, dateTo, typeTank, orderId, layout = DashboardLayoutStore.getLayout()) {

        // Filter only the type tanks that we need calculate the availability
        var filterTanks = this.getTanks().filter(function (column) {
            return column.type === typeTank;
        });

        // Iterate each of tank that we need to calculate their availability about `dateFrom` and `dateTo` params.
        var tanksAvailability = filterTanks.map(function (tank) {

            var dateFromText = DateUtils.toDateText(dateFrom),
                dateToText = DateUtils.toDateText(dateTo),
                newPosition,
                idOrderCollision,
                rangeCollisions;

            // Convert `dateFrom` and `dateTo` to position of layout in order to allow calculate if are available or not these dates.
            newPosition = {
                x: tank.column,
                h: ChronologycStore.getHFromDate(dateFromText, dateToText),
                y: ChronologycStore.getYFromDate(dateFromText),
                i: orderId || -1 // Is optional, because if dont define `orderId`, the search of collision will not take care about ID of order.
            };

            // Calculate if exist same other order in the `newPosition` that collision.
            rangeCollisions = DashboardLayoutStore.getRangeCollisions(newPosition, layout) || [];

            // In case that exist collision, save the Id of first of order to collision.
            if (rangeCollisions.length > 0) {
                idOrderCollision = _.map(rangeCollisions, range => ContentUtils.cleanId(_.get(range, 'rangeConflict.id')));
            }

            // Retrieve all the information needed to handler the availability or not of given `dateFrom`, `dateTo`, `typeTank`
            // And `orderId`.
            return {
                id: tank.id,
                type: tank.type,
                column: tank.column,
                volume: tank.volume,
                unit: tank.unit,
                name: tank.name,
                isAvailable: rangeCollisions.length === 0,
                idOrderCollision: idOrderCollision
            };
        }.bind(this));

        return tanksAvailability;
    },

    /**
     * Return the next Single tank available.
     * @param fromDate
     * @param toDate
     * @param orderId
     * @returns {*}
     * @private
     */
    getNextSingleTankAvailable(fromDate, toDate, orderId, volume, tankType, layout) {
        const availableTanks = this.getAvailabilityTanks(fromDate, toDate, tankType, orderId, layout);
        return this._getNextMostSuitableTank(availableTanks, (volume || 0));
    },

    /**
     * Return the previous Single tank available.
     * @param fromDate
     * @param toDate
     * @param orderId
     * @returns {*}
     * @private
     */
    getPreviouseSingleTankAvailable(fromDate, toDate, orderId, volume, tankType, layout) {
        const availableTanks = this.getAvailabilityTanks(fromDate, toDate, tankType, orderId, layout);
        return this._getBeforeMostSuitableTank(availableTanks, (volume || 0));
    },

    /**
     * Return the next Brite tank available.
     * @param filtrationDate
     * @param orderDate
     * @param orderId
     * @returns {*}
     * @private
     */
    getNextBriteTankAvailable(filtrationDate, orderDate, orderId, volume, layout) {
        const availableTanks = this.getAvailabilityTanks(filtrationDate, orderDate, 'BT', orderId, layout);
        return this._getNextMostSuitableTank(availableTanks, (volume || 0));
    },

    /**
     * Return the next Brite tank available.
     * @param filtrationDate
     * @param orderDate
     * @param orderId
     * @returns {*}
     * @private
     */
    getPreviousBriteTankAvailable(filtrationDate, orderDate, orderId, volume, layout) {
        const availableTanks = this.getAvailabilityTanks(filtrationDate, orderDate, 'BT', orderId, layout);
        return this._getBeforeMostSuitableTank(availableTanks, (volume || 0));
    },

    /**
     * Return the next Brite tank available.
     * @param filtrationDate
     * @param orderDate
     * @param orderId
     * @returns {*}
     * @private
     */
    getNextFermenterTankAvailable(brewDate, filtrationDate, orderId, volume, layout) {
        const availableTanks = this.getAvailabilityTanks(brewDate, filtrationDate, 'FV', orderId, layout);
        return this._getNextMostSuitableTank(availableTanks, (volume || 0));
    },

    /**
     * Return the next Brite tank available.
     * @param filtrationDate
     * @param orderDate
     * @param orderId
     * @returns {*}
     * @private
     */
    getPreviousFermenterTankAvailable(brewDate, filtrationDate, orderId, volume, layout) {
        const availableTanks = this.getAvailabilityTanks(brewDate, filtrationDate, 'FV', orderId, layout);
        return this._getBeforeMostSuitableTank(availableTanks, (volume || 0));
    },

    /**
     * Given list of tanks and volume, return the most suitable tank.
     * @param availableTanks
     * @param volume
     * @return {*}
     * @private
     */
    _getNextMostSuitableTank(availableTanks, volume) {
        const tanksAvailablesAndSuitables = _.filter(availableTanks, tank => tank.isAvailable === true && +tank.volume >= +volume);
        const tanksAvailablesWithNumberVolume = _.map(tanksAvailablesAndSuitables, tank => {
            tank.volume = +tank.volume;
            return tank;
        });
        return _.first(_.orderBy(tanksAvailablesWithNumberVolume, 'volume'));
    },

    _getBeforeMostSuitableTank(availableTanks, volumeTarget) {
        let tanksAvailablesAndSuitables = _.filter(availableTanks, tank => tank.isAvailable === true);
        const tanksAvailablesWithNumberVolume = _.map(tanksAvailablesAndSuitables, tank => {
            tank.volume = +tank.volume;
            return tank;
        });
        tanksAvailablesAndSuitables = _.orderBy(tanksAvailablesWithNumberVolume, 'volume');
        return _.find(tanksAvailablesAndSuitables, tank => (+tank.volume) + 1 >= volumeTarget);
    },

    getTanks() {
        return DashboardServiceCache.getTanks();
    },

    getTankById(tankId) {
        return find(DashboardServiceCache.getTanks(), tank => tankId === _.get(tank, 'id'));
    },

    getTankByColumn(column, success) {
        var tanks = DashboardServiceCache.getTankByColumn(column);
        if (success) {
            success(tanks);
        }
        return tanks;
    },

    getTankByType(column, success) {
        var tanks = DashboardServiceCache.getTankByType(column);
        if (success) {
            success(tanks);
        }
        return tanks;
    },

    /**
     * Retrieve the position new of brite tank.
     * @param {Object}   order
     * @param {Object}   positionNew
     * @param {Object}   positionOld
     * @return {Object}
     */
    getPositionBriteTankFromFermenter(order, positionFVNew, positionFVOld) {
        var boxBT = DashboardLayoutStore.getLayout().filter(function (box) {
                if (box && order) {
                    return box.i === order.id + '_BT';
                }
                return false;
            })[0],
            newFiltrationPosition = (positionFVNew.y + positionFVNew.h) - 1,
            briteTankOrderId = order.id + '_BT',
            newBriteTankH = boxBT.h;

        if (positionFVNew.h !== positionFVOld.h) {
            // Enter here means that the fermentation date was changed by resizing the order. So we need to calculate the new height (h)
            // of Packaging date.
            if (positionFVNew.h < positionFVOld.h) {
                newBriteTankH = (positionFVOld.h - positionFVNew.h) + this.getBriteTank(order.id).h;
            } else {
                newBriteTankH = this.getBriteTank(order.id).h - (positionFVNew.h - positionFVOld.h);
            }
        }

        if (!boxBT) {
            // Enter here means that BT is out of range of range of current dashboard.
            return null;
        }

        return {
            y: newFiltrationPosition,
            x: boxBT.x,
            h: newBriteTankH,
            i: briteTankOrderId,
            batchNumber: _.get(order, 'batchNumber'),
            isSingle: _.get(order, 'isSingle')
        };
    },

    getPositionFermenterFromBriteTank(order, positionBTNew, positionBTOld) {
        var boxFermenter = DashboardLayoutStore.getLayout().filter(function (box) {
                if (box && order) {
                    return box.i === order.id;
                }
                return false;// means that fermenter is out of range of current dashboard
            })[0],
            newBrewDayPosition,
            newBriteTankH;

        if (!boxFermenter) {
            return null;
        }
        newBriteTankH = boxFermenter.h;
        if (positionBTNew.h !== positionBTOld.h) {
            // Enter here means that the fermentation date was changed by resizing the order. So we need to calculate the new height (h)
            // of Packaging date.
            if (positionBTNew.h < positionBTOld.h) {
                newBriteTankH = (positionBTOld.h - positionBTNew.h) + this.getFilterTank(order.id).h;
            } else {
                newBriteTankH = this.getFilterTank(order.id).h - (positionBTNew.h - positionBTOld.h);
            }
        }

        newBrewDayPosition = (positionBTNew.y - boxFermenter.h) + 1;

        return {
            y: newBrewDayPosition,
            x: boxFermenter.x,
            h: newBriteTankH,
            i: order.id,
            batchNumber: _.get(order, 'batchNumber'),
            isSingle: _.get(order, 'isSingle')
        };
    },

    getBriteTank(orderId) {
        return _.find(DashboardLayoutStore.getLayout(), box => box.i === orderId + '_BT');
    },

    getFilterTank(orderId) {
        return _.find(DashboardLayoutStore.getLayout(), box => box.i === orderId);
    },

    getBriteTankPosition(order) {
        return {
            h: ChronologycStore.getHFromDate(order.filtrationDate, order.orderDate),
            x: _.get(order, 'briteTank.column'),
            y: ChronologycStore.getYFromDate(order.filtrationDate),
            i: order.id + '_BT',
            w: 1,
            batchNumber: _.get(order, 'batchNumber'),
            isSingle: _.get(order, 'isSingle'),
            static: true
        };
    },

    getFermenterTankPosition(order) {
        let x;
        if(order.fermenterTank){
           x=order.fermenterTank.column;
        } else {
           x=order.singleTank.column;
        }
        return {
            h: ChronologycStore.getHFromDate(order.brewDate, order.filtrationDate),
            x: x,
            y: ChronologycStore.getYFromDate(order.brewDate),
            i: String(order.id),
            w: 1,
            batchNumber: _.get(order, 'batchNumber'),
            isSingle: _.get(order, 'isSingle'),
            static: true
        };
    },

    getFermenterTankPositionManual(orderId, column, brewDate, filtrationDate, batchNumber, isSingle) {
        return {
            h: ChronologycStore.getHFromDate(brewDate, filtrationDate),
            x: column,
            y: ChronologycStore.getYFromDate(brewDate),
            i: String(orderId),
            batchNumber,
            isSingle,
            w: 1,
            static: true
        };
    },

    getSingleTankPosition(singleOrder) {
        let fromDate;
        let toDate;
        if (typeof singleOrder.fromDate === 'string') {
            fromDate = singleOrder.fromDate;
        } else {
            fromDate = DateUtils.toDateText(singleOrder.fromDate);
        }
        if (typeof singleOrder.toDate === 'string') {
            toDate = singleOrder.toDate;
        } else {
            toDate = DateUtils.toDateText(singleOrder.toDate);
        }
        const postFix = _.get(singleOrder, 'singleTank.type') === 'BT' ? '_BT' : '';
        const id = String(singleOrder.id) + postFix;
        return {
            h: ChronologycStore.getHFromDate(fromDate, toDate),
            x: _.get(singleOrder, 'singleTank.column'),
            y: ChronologycStore.getYFromDate(fromDate),
            batchNumber: _.get(singleOrder, 'batchNumber'),
            i: id,
            w: 1,
            static: true,
            isSingle: true
        };
    },

    isFirstTankHigherOrEquals(tankHigherColumn, tankColumn) {
        const tankHigher = this.getTankByColumn(tankHigherColumn);
        const tank = this.getTankByColumn(tankColumn);

        if (tankHigher && tank) {
            return +tankHigher.volume >= +tank.volume;
        }

        return false;
    }

};

module.exports = TankStore;



/** WEBPACK FOOTER **
 ** ./src/stores/TankStore.js
 **/